export const defaultSettings = {
    work: {
        mins: 25,
        label: 'WORK',
    },
    shortBreak: {
        mins: 5,
        label: 'SHORT BREAK',
    },
    longBreak: {
        mins: 15,
        label: 'LONG BREAK',
    },
    autoStartBreak: false,
    autoStartPomodoro: false,
    longBreakInterval: 4,
    alarmFileName: 'alarm_sound.mp3',
};
